import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyName } from '@webapp/models/enums'
import { FinancialAccountTypes } from '@webapp/models/enums/FinancialAccountType'
import { PaymentSourceTransactionStatuses } from '@webapp/models/enums/PaymentSourceTransactionStatus'
import {
  type PaymentSourceBalanceResponse,
  type PaymentSourceFundDetailsResponse,
  type PaymentSourceGLCodeResponse,
  type PaymentSourceOnboardingLinkResponse,
  type PaymentSourceResponse,
  type PaymentSourceTransactionResponse,
  type RequestForInformationLinkResponse,
} from '@webapp/models/PaymentSource'
import { FinancialAccountStatuses } from '@webapp/platform/banking/entities/enums/FinancialAccountStatusEnum'

export const PaymentSourceResponseMock =
  Factory.Sync.makeFactory<PaymentSourceResponse>({
    id: Factory.each(() => faker.random.number()),
    type: FinancialAccountTypes.AIRWALLEX_CAD,
    status: FinancialAccountStatuses.ACTIVE,
  })

export const PaymentSourceOnboardingLinkResponseMock =
  Factory.Sync.makeFactory<PaymentSourceOnboardingLinkResponse>({
    url: faker.internet.url(),
  })

export const PaymentSourceBalanceResponseMock =
  Factory.Sync.makeFactory<PaymentSourceBalanceResponse>({
    balance: Factory.each(() => faker.random.number(100000).toString()),
    currency: CurrencyName.CAD,
  })

export const PaymentSourceFundDetailsResponseMock =
  Factory.Sync.makeFactory<PaymentSourceFundDetailsResponse>({
    account_name: faker.company.companyName(),
    account_number: Factory.each(() => faker.finance.account(10)),
    institution_number: Factory.each(() => faker.finance.account(3)),
    transit_number: Factory.each(() => faker.finance.account(5)),
    routing_number: Factory.each(() => faker.finance.account(9)),
    sort_code: Factory.each(() => faker.finance.account(6)),
  })

export const PaymentSourceTransactionMock =
  Factory.Sync.makeFactory<PaymentSourceTransactionResponse>({
    created_date: Factory.each(() => faker.date.past().toISOString()),
    description: Factory.each(() => faker.finance.transactionType()),
    status: Factory.each(() =>
      faker.random.arrayElement(Object.values(PaymentSourceTransactionStatuses))
    ),
    amount: Factory.each(() => faker.random.number(99999).toString()),
    currency: CurrencyName.CAD,
  })

export const PaymentSourceGLCodeResponseMock =
  Factory.Sync.makeFactory<PaymentSourceGLCodeResponse>({
    gl_code: Factory.each(() => faker.random.number(99999).toString()),
  })

export const PaymentSourceRequestForInformationLinkResponseMock =
  Factory.Sync.makeFactory<RequestForInformationLinkResponse>({
    url: faker.internet.url(),
  })
